const LIGHT_TYPE = {
  Lamp: 'LAMP',
  Monitor: 'MONITOR',
}

export { LIGHT_TYPE };
